<template>
    <v-container>
        
        <!-- <v-tabs v-model="tab">
            <v-tab :key="actionLog" @click="changeTab(key)">開催データ</v-tab> -->
            
            <!-- <v-tab
                    v-for="tabsItem in ui_tabsItems"
                    :key="tabsItem.id"
                    @change="changeTab(tabsItem.label)"
            >
                 <span class="pl-2 pr-2">{{ tabsItem.title }}</span>
            </v-tab> -->

        <!-- </v-tabs> -->
        <v-btn @click="changeTab(ALL)" :color="data_type==ALL?'primary':''">全体</v-btn>
        <v-btn @click="changeTab(INDIV)" :color="data_type==INDIV?'primary':''">個人主催</v-btn>
        <v-btn @click="changeTab(INDIV_ATTEND)" :color="data_type==INDIV_ATTEND?'primary':''">個人参加</v-btn>
        
        <!-- <v-tabs-items v-model="tab">
            <v-tab-item key="actionLog"
            > -->
                <v-card flat>
                    <v-flex xs4>
                        <v-radio-group 
                            v-model="radioGroup"
                            row
                            class='ml-2'
                        >
                            <v-radio
                                v-for="n in unitlabel.length"
                                :key="n"
                                :label="unitlabel[n-1]"
                                :value="n"
                                @change="calc(n)"
                            ></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <v-flex xs4>
                        <v-menu
                            v-model="menu_date"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dates"
                                label="期間"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="dates"
                                no-title
                                locale="jp-ja"
                                :day-format="date => new Date(date).getDate()"
                                range
                                @change="getEvents"
                            ></v-date-picker>
                        </v-menu>
                    </v-flex>
                <!-- <v-btn color="info" @click="getEvents">Get</v-btn> -->
                <!-- <v-btn color="info" @click="calc">Calc</v-btn> -->
                <!-- <div>{{$store.state.events.events.length}}</div> -->
                <template>
                <div>
                    <div v-if="data_type != INDIV_ATTEND">
                        <h1>開催数</h1>
                        <Chart :chart-data="datacollectionHold" ></Chart>
                        <h1>参加者数</h1>
                        <Chart :chart-data="datacollectionAttend" ></Chart>
                    </div>
                    <div v-if="data_type == INDIV_ATTEND">
                        <h1>参加数</h1>
                        <Chart :chart-data="datacollectionOwnAttend" ></Chart>
                    </div>
                </div>
                </template>
                <template>
                    <div v-if="data_type != INDIV_ATTEND">
                        <h1>開催数と参加者数</h1>
                    </div>
                    <div v-if="data_type == INDIV_ATTEND">
                        <h1>参加数</h1>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="tabledata"
                        class="elevation-1"
                        dense
                    ></v-data-table>
                </template>

                </v-card>
        
            <!-- </v-tab-item>
        </v-tabs-items> -->
    </v-container>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import Chart from './Chart.vue';
    export default {
        computed: {
            ...mapGetters(["userName", "photoURL", 'chatwork_id', 'uid', 'role', 'login_user']),
            ...mapGetters("chartdata", ["datacollectionHold", "datacollectionAttend", "datacollectionOwnAttend", "start", "end", "tabledata"]),
        },
        components: {
            Chart,
        },
        // props: {
        //     event_type: String,
        //     navItem: String,
        // },
        mounted(){
            console.log('mounted')
            //期間の初期化
            //前月
            let start = new Date()
            start.setMonth(start.getMonth() - 1)
            start.setDate(1)
            //今月の最終日
            let end = new Date()
            end.setMonth(end.getMonth() + 1)
            end.setDate(0)

            //カレンダーデータの初期化
            this.dates.push(this.formatDate(start))
            this.dates.push(this.formatDate(end))

            this.data_type = this.ALL

            this.updateUnit(this.unitlabel[this.radioGroup -1])
            this.getEvents()
            this.updateHeader();
            console.log('')

        },
        data() {
            return {
                ALL : 'all',
                INDIV : 'indiv',
                INDIV_ATTEND : 'indiv_attend',
                tab: null,
                
                tabsItems: [
                    {id: 1, title: "全体", label: "all"},
                    {id: 2, title: "個人", label: "indiv"},
                ],

                radioGroup: 2,
                // unitlabel: ["年", "月", "週", "日"],
                unitlabel: ["月", "週", "日"],
                menu_date: false,
                dates: [],
                headers: [
                    {
                        text: '',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                    },
                    { text: '開催数', value: 'hold' },
                    { text: '参加者数', value: 'attend' },
                ],
                data_type : null,

                event_type : 'seminar',
                navItem : 'S'
            };
        },
        methods:{
            ...mapActions(["getEvent"]),
            ...mapActions('chartdata', ["updateStart", "updateEnd", "updateChartData", "updateUnit"]),
            formatDate(dt){
                return `${dt.getFullYear()}-${(dt.getMonth()+1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')}`.replace(/\n|\r/g, '')
            },
            updateStartEnd(){
                //datesは、順番関係なく先に選択された順に入るので、早い方をstartに入れる
                if(this.dates[0] <= this.dates[1]){
                    // this.start = this.dates[0]
                    // this.end = this.dates[1]
                    this.updateStart(this.dates[0])
                    this.updateEnd(this.dates[1])
                }else{
                    // this.start = this.dates[1]
                    // this.end = this.dates[0]
                    this.updateStart(this.dates[1])
                    this.updateEnd(this.dates[0])
                }
            },
            getEvents () {
                this.updateStartEnd();
                this.$store.state.events.start = this.start
                this.$store.state.events.end = this.end
                    console.log('get_event0')
                if(this.login_user){
                    console.log('get_event')
                    this.getEvent({event_type:this.event_type?this.event_type:'S', navItem:this.navItem?this.navItem:'seminar', start:this.start, end:this.end});
                }
            },
            calc(n){
                //ラジオボタンの反映
                this.updateUnit(this.unitlabel[n - 1])

                //集計
                this.updateChartData(this.$store.state.events.events)
            },
            changeTab(type){
                if(type == this.ALL && this.data_type != this.ALL){
                    this.data_type = this.ALL;
                    this.navItem = 'seminar';
                    this.event_type = 'S';
                }else if(type == this.INDIV && this.data_type != this.INDIV){
                    this.data_type = this.INDIV;
                    this.navItem = 'host';
                    this.event_type = 'S'
                }else if(type == this.INDIV_ATTEND && this.data_type != this.INDIV_ATTEND){
                    this.data_type = this.INDIV_ATTEND;
                    this.navItem = 'attend';
                    this.event_type = 'S'
                }
                this.getEvents();
                this.updateHeader();
            },
            updateHeader(){
                if(this.data_type == this.INDIV_ATTEND){
                    this.headers = [
                        {
                            text: '',
                            align: 'start',
                            sortable: false,
                            value: 'name',
                        },
                        { text: '参加数', value: 'ownattend' },
                    ]

                }else{
                    this.headers = [
                        {
                            text: '',
                            align: 'start',
                            sortable: false,
                            value: 'name',
                        },
                        { text: '開催数', value: 'hold' },
                        { text: '参加者数', value: 'attend' },
                    ]
                }
            }

        }
    };
</script>
